export const isDecemberUK = () => new Intl.DateTimeFormat("en-GB", { month: "numeric", timeZone: "Europe/London" }).format(new Date()) === "12";
